import { Component } from 'react'
import PropTypes from 'prop-types'

import { saveRegistry } from 'registry/actions'

import { Form } from 'components/forms'
import { SaveButton } from 'components/buttons'
import LinkCopier from 'registry/share-page/containers/link-copier'

import RegistryVisibilityFieldSet from './registry-visibility-fieldset.jsx'

class RegistryVisibility extends Component {
  // eslint-disable-next-line react/static-property-placement
  static propTypes = {
    fields: PropTypes.shape({
      passwordAccess: PropTypes.object,
      registry: PropTypes.shape({
        isShippingAddressPrivate: PropTypes.object,
        searchLevel: PropTypes.object,
        visitorPassword: PropTypes.object,
      }),
    }).isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired,
    layout: PropTypes.string,
  }

  // eslint-disable-next-line react/static-property-placement
  static defaultProps = {
    // eslint-disable-next-line react/default-props-match-prop-types
    onSubmitSuccess: () => {},
  }

  // eslint-disable-next-line class-methods-use-this
  _handleSubmit(values, dispatch) {
    if (!values.passwordAccess) {
      values.registry.visitorPassword = null
    }

    values.registry.privateAddress = !!values.registry.isShippingAddressPrivate

    return dispatch(saveRegistry(values))
  }

  render() {
    const {
      fields: {
        passwordAccess,
        registry: { visitorPassword, searchLevel, isShippingAddressPrivate },
      },
      handleSubmit,
      submitting,
      layout,
    } = this.props

    return (
      <>
        <LinkCopier />
        <Form onSubmit={handleSubmit(this._handleSubmit.bind(this))}>
          <RegistryVisibilityFieldSet
            isShippingAddressPrivate={isShippingAddressPrivate}
            passwordAccess={passwordAccess}
            searchLevel={searchLevel}
            visitorPassword={visitorPassword}
          />
          {layout === 'modal' ? (
            <div className="flex center">
              <SaveButton pill submitting={submitting} />
            </div>
          ) : (
            <SaveButton pill submitting={submitting} />
          )}
        </Form>
      </>
    )
  }
}

export default RegistryVisibility
